import * as React from 'react';

import { useDispatch } from 'react-redux';
import { Button, Theme, TextField } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { makeStyles } from '@material-ui/core/styles';
import { useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import { consts } from '../../common/consts'
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Grid from '@material-ui/core/Grid';
import { HashLink as Linkk } from 'react-router-hash-link';
import { useHistory } from "react-router-dom";

import { ReactComponent as SMALogo } from '../../assets/svgs/smalogo.svg';
import chipIcon from '../../assets/svgs/chipp.svg';
import timeIcon from '../../assets/svgs/time.svg'
import calendarIcon from '../../assets/svgs/calendar.svg'
import asset10 from '../../assets/images/Asset-10.png'
import asset11 from '../../assets/images/Asset-11.png'
import asset12 from '../../assets/images/Asset-12.png'
import asset13 from '../../assets/images/Asset-13.png'
import asset14 from '../../assets/images/Asset-14.png'

import login1 from '../../assets/svgs/login/login-1.svg'
import login2 from '../../assets/svgs/login/login-2.svg'
import login4 from '../../assets/svgs/login/login-4.svg'
import login5 from '../../assets/svgs/login/login-5.svg'
import login6 from '../../assets/svgs/login/login-6.svg'
import login7 from '../../assets/svgs/login/login-7.svg'
import login8 from '../../assets/svgs/login/login-8.svg'
import footerLogo from '../../assets/svgs/login/footer-logo.svg'
import AusMadeLogo from '../../assets/svgs/login/aus-made-logo.svg'
import AusOperatedLogo from '../../assets/images/AO-logo.png'
import { signIn } from './loginHelpers';

interface LoginWidgetProps extends React.Props<any> {
    finishLogin(isSuccess: boolean, token: string): void,
    goToForgotPassword(): void,
    goToLoginOTP(username: string, password: string, isSMS: boolean): void
};

interface Props {
    window?: () => Window;
    children: React.ReactElement;
}

function ElevationScroll(props: Props) {
    const { children, window } = props;
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        target: window ? window() : undefined,
    });

    return React.cloneElement(children, {
        elevation: trigger ? 4 : 0,
    });
}

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: 0,
        margin: 0,
    },

    inputs: {
        fontSize: 14,
    },

    button: {
        minWidth: 200,
        backgroundColor: '#FFB500',
        color: '#ffffff',
        borderRadius: 30,
        marginBottom: 40,
        '&:hover': {
            color: '#0049a3',
            backgroundColor: '#FFFFFF',
        },
    },
    link: {
        color: '#F5F5F5',
        paddingLeft: 0,
        fontSize: 'small'
    },
    logoImg: {
        display: 'block',
        marginTop: 20,
        marginLeft: 'auto',
        marginRight: 'auto',
        width: 374.67,
    },
    logoRoot: {
        height: 212,
    },
    alertErrorRoot: {
        marginBottom: 20,
    },
    textFieldRoot: {
        width: '100%',
        marginBottom: 20,
        '& .MuiOutlinedInput-root': {

            '&:hover fieldset': {
                borderColor: 'rgba(255,255,255, 0.25)',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'rgba(255,255,255, 0.25)',
            },
        },
        '& .MuiOutlinedInput-input': {
            padding: '10px 10px',
        },
        borderRadius: '5px',
    },

    textFieldInput: {
        backgroundColor: '#ffffff',
        color: '#666666',
        borderRadius: '0px',
    },

    logo: {
        width: 200,
        height: 180,

    },
    navbar: {
        height: 142,
        display: 'flex',
        alignContent: 'center',
        position: 'sticky',
        justifyContent: 'center',
    },
    background: {
        backgroundColor: '#001630',
        backgroundImage: 'url(https://smalive.wisdom.com.au/app/uploads/2021/06/bg-overlay-03-1.jpg)',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    },
    header: {
        justifyContent: 'center',
        backgroundImage: 'url(https://smalive.wisdom.com.au/app/uploads/2021/06/bg-overlay-02.png)',
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        opacity: '1',
        transition: 'background 0.3s, border-radius 0.3s, opacity 0.3s',
        display: 'flex',
        padding: '350px 0px 300px 0px',
    },
    widgetHeadings: {
        fontSize: 35,
        fontWeight: 800,

    },
    widgetBody: {
        fontSize: 16,
        fontWeight: 600,
    },
    contentContainer: {
        maxWidth: 1700,
        margin: 'auto',
        width: "-webkit-fill-available",
        paddingLeft: 50,
        paddingRight: 50,
    },

    "@-moz-document url-prefix()": {
        contentContainer: {
            width: "-moz-available",
        },
    },

    headerBody: {
        display: 'flex',
    },
    widgetContent: {
        padding: 40,
        textAlign: 'center',
    },
    icon: {
        width: '70px',
        height: '70px',
    },
    menuBody: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    menu: {
        fontWeight: 700,
        fontSize: '16px',
        textDecorationThickness: '0px',
        textDecoration: 'none',
        color: '#FFF',
        padding: '20px',
        '&:hover': {
            textDecoration: 'underline',
            color: '#FFB500',
            textDecorationThickness: '3px',
            textUnderlineOffset: '10px'
        },

    },

    loginButton: {
        textDecoration: 'none',
        color: '#fff',
        '&:hover': {
            color: '#0049A3',
        },
    },

    body: {
        display: 'flex',
        justifyContent: 'center'
    },
    widgets: {
        display: 'flex',
        alignContent: 'space-between',
        alignItems: 'space-between',
        justifyContent: 'space-between',
    },
    yAdjustment: {
        '--translateY': '-147.9px',
        transform: 'translateY(var(--translateY))',
    },
    widget: {
        backgroundColor: '#FFB500',
        borderRadius: '20px',
        width: '32%',
        maxWidth: '32%',
        textAlign: 'center',
    },
    headerLogin: {
        flexGrow: 1,
    },
    headerHeading: {
        flexGrow: 2,
        display: 'flex',
    },
    heading: {
        fontSize: '100px',
        color: '#FFFFFF',
        fontWeight: 800,
        lineHeight: '1.2em',
        margin: 0,
    },
    loginHeaderButton: {
        backgroundColor: '#FFB500',
        borderRadius: 30,
        padding: '12px 30px',
        fontSize: 14,
        fontWeight: 800,
        '&:hover': {
            color: '#0049a3',
            backgroundColor: '#FFFFFF',
        },
    },
    loginText: {
        color: '#ffffff',

    },
    bodyHeading: {
        fontSize: 50,

    },
    aboutArea: {
        
    },
    h3: {
        fontSize: 30,
    },
    p: {
        fontSize: 20,
    },
    emailLink: {
        color: '#5292d1',
        textDecoration: 'none',
    },
    loginBodyButton: {
        backgroundColor: '#FFB500',
        color: '#fff',
        borderRadius: 30,
        textDecoration: 'none',
        padding: '12px 60px',
        fontSize: 14,
        fontWeight: 800,
        '&:hover': {
            color: '#fff',
            backgroundColor: '#0049a3',
            textDecoration: 'none',
        },
    },
    bodyDivider: {
        borderRight: '2px solid #5292d1',
    },
    divider: {
        height: 120,
        backgroundColor: 'transparent',
        backgroundImage: 'linear-gradient(180deg, #0049A300 0%, #0049A352 100%)',
        opacity: '0.5',
        marginBottom: 100,
    },
    partners: {
        paddingTop: 40,
        paddingBottom: 40,
        display: 'flex',
        justifyContent: 'space-evenly'
    },
    andMore: {
        backgroundColor: '#ffb500'
    },
    footericons: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        textAlign: 'center',
        flexWrap: 'wrap',
    },
    iconCaption: {
        fontSize: 22,
        fontWeight: 600,
        color: '#0049A3',
    },
    iconContainer: {
        width: '25%',
        maxWidth: '25%',
    },
    footer: {
        backgroundColor: '#001630',
        minHeight: 300,
        display: 'flex',
        textAlign: 'center',
        justifyContent: 'center',
    },
    footerLogo: {
        width: '269px',
    },
    footerLink: {
        color: '#fff',
        padding: 20,
        cursor: 'pointer',
        fontWeight: 'bold',
        '&:hover': {
            color: '#FFB500',
        },
    }
}));

function NewlineText(props: any) {
    const text = props.text;
    return <div style={{ whiteSpace: 'pre-wrap' }}>{text}</div>;
}

function LoginWidget(props: LoginWidgetProps): JSX.Element {
    const { handleSubmit, errors, control, formState, trigger, watch } = useForm();
    const preventDefault = (event: { preventDefault: () => any; }) => event.preventDefault();
    const history = useHistory();
    const dispatch = useDispatch();

    const classes = useStyles();

    const [errorMessage, setErrorMessage] = useState("");

    const [showPassword, setShowPassword] = useState(false);

    const TermsPage = () => {
        history.push('/terms-and-conditions');
    }

    const PrivacyPage = () => {
        history.push('/privacy');
    }

    const LoginPage = () => {
        history.push('/login');
    }

    const handleSignIn = async (data: any) =>{
        await signIn(
            data,
            dispatch,
            props.finishLogin,
            props.goToLoginOTP,
            setErrorMessage
        );
    }

    const handleClickShowPassword = () => {

        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };
    
    const emailValue = watch("email", "");
    React.useEffect(() => {
        if (/[0-9]+/.test(emailValue)) {
            trigger();
        }
    }, [emailValue])

    return (
        <React.Fragment>
            <div className={classes.root}>
                <ElevationScroll {...props}>
                    <AppBar color='transparent' style={{boxShadow: 'none'}}>
                        <Toolbar className={classes.navbar}>
                            <div className={classes.contentContainer} style={{ width: '-moz-available'}}>
                                <div className={classes.menuBody}>
                                    <SMALogo className={classes.logo} onClick={LoginPage} style={{ cursor: 'pointer' }}/>
                                    <div>
                                        <Linkk smooth to="#about" className={classes.menu}>
                                            Overview
                                        </Linkk>
                                        <Linkk
                                            smooth href="#" to="#partners" className={classes.menu}>
                                            Our Partners
                                        </Linkk>
                                        <Linkk smooth href="#" to="#andMore"  className={classes.menu}>
                                            More Features
                                        </Linkk>
                                        <Button variant="contained" color="primary" className={classes.loginHeaderButton}>
                                            <Linkk className={classes.loginButton} smooth href="#"  to="#login-box" > Login </Linkk>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Toolbar>
                    </AppBar>
                </ElevationScroll>

                <section style={{ backgroundImage: 'linear-gradient(180deg, #0016308C 0%, #00163000 100%)', backgroundColor: "transparent", position: 'fixed', width: '100%', height: '142px', zIndex: 1000, }}>
                </section>

                <section className={classes.background}>
                    <div className={classes.header} id="login-box" >
                        <div className={classes.contentContainer} style={{ width: '-moz-available' }}>
                            <Grid spacing={3} className={classes.headerBody} container>
                                <Grid item xs={7} sm={8} className={classes.headerHeading}>
                                    <h1 className={classes.heading}>
                                        Patient Transport, <br />
                                        Done Right.
                                    </h1>
                                </Grid>
                                <Grid item xs={5} sm={4} className={classes.headerLogin}>
                                    <form onSubmit={handleSubmit(handleSignIn)} >
                                        <h2 className={classes.loginText}>Login</h2>
                                        <div className={classes.inputs}>
                                            <Controller
                                                defaultValue=''
                                                control={control}
                                                as={<TextField classes={{ root: classes.textFieldRoot }} InputProps={{ classes: { root: classes.textFieldInput } }} variant='outlined' placeholder='Email Address / Employee Id' error={errors.email} helperText={errors.email ? errors.email.message : ""} />}
                                                name='email'
                                                rules={{
                                                    required: "Email Address / Employee Id is required",
                                                    pattern: {
                                                        value: consts.EmailEmployeeIDRegex,
                                                        message: "Invalid email address / employee id"
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className={classes.inputs}>
                                            <Controller
                                                defaultValue=''
                                                control={control}
                                                as={<TextField classes={{ root: classes.textFieldRoot }} InputProps={{
                                                    classes: {
                                                        root: classes.textFieldInput
                                                    },
                                                    endAdornment: <InputAdornment position="end">
                                                        <IconButton style={{ color: '#fff' }}
                                                            aria-label="toggle password visibility"
                                                            onClick={handleClickShowPassword}
                                                            onMouseDown={handleMouseDownPassword}>
                                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                }} variant='outlined' placeholder='Password' type={showPassword ? 'text' : 'password'} error={errors.password} helperText={errors.password ? errors.password.message : ""} />}
                                                name='password'
                                                rules={{
                                                    validate: (value) => {
                                                        if (/[0-9]+/.test(emailValue))
                                                            return true;
                                                        else if (value === "")
                                                            return "Password is required";
                                                        return true;
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <Button onClick={() => props.goToForgotPassword()} className={classes.link}>
                                                Forgot your password?
                                            </Button>
                                        </div>
                                        <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" classes={{ root: classes.alertErrorRoot }} style={{ display: errorMessage ? 'flex' : 'none' }}>
                                            <NewlineText text={errorMessage} />
                                        </Alert>
                                        <div className={classes.inputs}>
                                            <Button type='submit'
                                                disabled={formState.isSubmitting}
                                                className={classes.button}
                                                variant="contained">Sign In</Button>
                                        </div>
                                    </form>
                                 </Grid>
                            </Grid>
                        </div>
                    </div>
                </section>
                <section className={classes.body}>
                    <div className={classes.yAdjustment}>
                        <div className={classes.contentContainer} style={{ width: '-moz-available' }}>
                            <div className={classes.widgets}>
                                <div className={classes.widget}>
                                    <div className={classes.widgetContent}>
                                        <img src={timeIcon} className={classes.icon} />
                                        <h1 className={classes.widgetHeadings}>Real-time ETAs</h1>
                                        <a className={classes.widgetBody}>SMA Live tracks routes, vehicle locations, pickup and dropoff locations, team and vehicle capabilities to deliver the best ETAs in the business.</a>
                                    </div>
                                </div>
                                <div className={classes.widget}>
                                    <div className={classes.widgetContent}>
                                        <img src={chipIcon} className={classes.icon} />
                                        <h1 className={classes.widgetHeadings}>Everyone in the Loop</h1>
                                        <a className={classes.widgetBody}>With SMA Live, everyone from the Ward to the ambulance is in the know about what's happening when.</a>
                                    </div>
                                </div>
                                <div className={classes.widget}>
                                    <div className={classes.widgetContent}>
                                        <img src={calendarIcon} className={classes.icon} />
                                        <h1 className={classes.widgetHeadings}>Flexible Scheduling</h1>
                                        <a className={classes.widgetBody}>Control your own schedule, or let us help plan your patient transport day. SMA Live makes it easy!</a>
                                    </div>
                                </div>
                            </div>
                            <div id="about" style={{height:150}}>
                            </div>
                            <Grid container spacing={6} direction="row" alignItems="center" className={classes.aboutArea}>
                                <Grid item xs={8} className={classes.bodyDivider}>
                                    <h2 className={classes.bodyHeading}>Oversight and control over all aspects of our leading patient transport service</h2>
                                    <p className={classes.p}>SMA Live gives you full visibility of the patient transport process, from ward booking to scheduling, though to tracking of the actual transfer. Through the SMA Live dashboard, you can track activity over time and look for opportunities to reduce costs or improve patient care outcomes.</p>
                                    <p className={classes.p}>SMA Live is available on a range of devices includes desktop computers, tablets and TV-based nurses station displays.</p>
                                </Grid>
                                <Grid item xs={4}>
                                    <h3 className={classes.h3}>Ready to get started?</h3>
                                    <p className={classes.p}>Call us on <b>1300 30 40 63</b>, or email <a className={classes.emailLink} href="mailto:info@statemedicalassistance.com.au">info@statemedicalassistance.com.au</a></p>
                                    <p className={classes.p}><b>Already on SMA Live?</b></p>
                                    <Linkk smooth href="#" to="#login-box"  className={classes.loginBodyButton}>
                                        Login
                                    </Linkk>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </section>
                <section className={classes.divider}>

                </section>
                <section className={classes.contentContainer}>
                    <div>
                        <div style={{ height: 5 }} id="partners">
                        </div>
                        <div style={{textAlign: 'center', marginBottom: 80}}>
                            <h1 className={classes.bodyHeading}>A Service You Can <a style={{ color: '#5292d1', }}>Depend</a> On</h1>
                            <p className={classes.p}>SMA Live is built to be secure, fast and available when you need it. To do this, we've leveraged the services and expertise of today's leading technology companies.</p>
                            <div className={classes.partners}>
                                <img src={asset10} />
                                <img src={asset11} />
                                <img src={asset12} />
                                <img src={asset13} />
                                <img src={asset14} />
                            </div>
                         </div>
                     </div>
                </section>
                <section className={classes.andMore} style={{paddingBottom:60,}}>
                    <div className={classes.contentContainer}>
                        <div id="andMore" style={{paddingTop: 100, paddingBottom: 60,}}>
                            <h1 style={{ textAlign: 'center', fontSize: 50, fontWeight: 700}}>And More...</h1>
                            <p style={{ textAlign: 'center', fontSize: 20, fontWeight: 700}}>For more information on these or any other features of SMA Live, please call us on <b>1300 30 40 63</b>.</p>
                        </div>
                            <div className={classes.footericons}>
                            <div className={classes.iconContainer}>
                                <div style={{padding: '0px 20px 40px 20px'}}>
                                    <img src={login2} />
                                    <p className={classes.iconCaption}>Vehicle Tracking</p>
                                </div>
                            </div>
                            <div className={classes.iconContainer}>
                                <div style={{padding: '0px 20px 40px 20px'}}>
                                    <img src={login4} />
                                    <p className={classes.iconCaption}>Dashboard</p>
                                </div>
                            </div>
                            <div className={classes.iconContainer}>
                                <div style={{ padding: '0px 20px 40px 20px' }}>
                                    <img src={login6} />
                                    <p className={classes.iconCaption}>Multi-Loading</p>
                                </div>
                            </div>  
                            <div className={classes.iconContainer}>
                                <div style={{ padding: '0px 20px 40px 20px' }}>
                                    <img src={login8} />
                                    <p className={classes.iconCaption}>Reasons For Delay</p>
                                </div>
                            </div>
                            <div className={classes.iconContainer}>
                                <div style={{ padding: '0px 20px 40px 20px' }}>
                                    <img src={login1} />
                                    <p className={classes.iconCaption}>Next-Of-Kin View</p>
                                </div>
                            </div>
                            <div className={classes.iconContainer}>
                                <div style={{ padding: '0px 20px 40px 20px' }}>
                                    <img src={login7} />
                                    <p className={classes.iconCaption}>Transfer History With Change Tracking</p>
                                </div>
                            </div>
                            <div className={classes.iconContainer}>
                                <div style={{ padding: '0px 20px 40px 20px' }}>
                                    <img src={login5} />
                                    <p className={classes.iconCaption}>User Self-Management</p>
                                </div>
                            </div>
                            <div className={classes.iconContainer}>
                                <div style={{ padding: '0px 20px 40px 20px' }}>
                                    <img src={login7} />
                                    <p className={classes.iconCaption}>Nurse Station Display</p>
                                </div>
                            </div>
                        </div>
                     </div>
                </section>
                <section className={classes.footer}>
                    <div className={classes.contentContainer} style={{ width: '100%' }}>

                        <div style={{ display: 'flex', flexDirection: 'row', alignContent: 'center', justifyContent: 'space-between' }}>

                            <div style={{ maxWidth: '300px', display: 'flex', textAlign: 'left', alignItems: 'center' }}>
                                <img src={AusOperatedLogo} style={{ width: 100, marginRight: 20,  }} />
                                <a style={{ color: '#fff' }}>State Medical Assistance (SMA) is proudly 100% Australian owned</a>
                            </div>

                            <div style={{ width: "1px", height: "auto", backgroundColor: 'rgba(255, 255, 255, 0.15)'}}>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', maxWidth: 300, textAlign: 'center', alignItems: 'center', }}>
                                <img src={footerLogo} className={classes.footerLogo} />
                                <a style={{ color: '#fff', marginTop: 10 }}>SMA Live is a product of State Medical Assistance</a>
                            </div>

                            <div style={{ width: "1px", height: "auto", backgroundColor: 'rgba(255, 255, 255, 0.15)' }}>
                            </div>

                            <div style={{ maxWidth: '300px', display: 'flex', textAlign: 'left', alignItems: 'center' }}>
                                <a style={{ color: '#fff'}}>SMA Live is proudly designed, developed and hosted in Australia (test update)</a>
                                <img src={AusMadeLogo} style={{ width: 100 }} />
                            </div>
                        </div>

                       
                        <div style={{ marginTop: 40, paddingTop: 40, borderTop: "1px solid rgba(255, 255, 255, 0.15)"}}>
                            <a onClick={TermsPage} className={classes.footerLink} >Terms of Use</a>
                            <a onClick={PrivacyPage} className={classes.footerLink}>Privacy Policy</a>
                        </div>
                    </div>
                </section>
            </div>

        </React.Fragment >
    );
}

export default React.memo(LoginWidget)